<button (click)="onButtonClick()" type="{{type}}" [ngClass]="classes()" [disabled]="disabled" [id]="id" >
  <ng-content></ng-content>
</button>
